import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@chakra-ui/react";

import { AdminNavbar, Sidebar } from "../../features/admin/components";
import { Breadcrumb } from "../../shared/components";

function AdminPage() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: windowWidth <= 768 ? "column" : "row", width: "100vw", height: "100vh" }}>
      <div>
        <Sidebar />
      </div>

      <div style={{ overflowX: 'hidden', width: "100%" }}>
        <AdminNavbar />
        <Breadcrumb />

        <div style={{ padding: 20 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
